import React, { useEffect, useRef, useState } from "react";
import RightNavigation from "../../Views/Navigation/RightNavigation";
// import { NewsFeed, post } from "../../config/imagesLink";
import PostInteractionModal from "../NewsFeed/PostInteractionModal";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import { Link, NavLink, useParams } from "react-router-dom";
import moment from "moment/moment";
import PostEngagement from "../NewsFeed/PostEngagement";
import ImageSliderModal from "../NewsFeed/ImageSliderModal";
import { PostDetailSkeleton, ImageWithLoader } from "@skeleton";
import SinglePostEngagement from "../NewsFeed/SinglePostEngagement";
import { header, post } from "../../config/imagesLink";
import Slider from "react-slick";
import SinglePostInteraction from "../NewsFeed/SinglePostInteraction";
import SinglePostComment from "../NewsFeed/SinglePostComment";
import LikesDetails from "../NewsFeed/LikesDetails";
import { Helmet } from "react-helmet";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import PostVideoCommon from "../PersonalProfile/PostVideoCommon";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from "react-i18next";
import formatPostContent, {
  formatExpandedPostContent,
} from "../../utility/formatPostContent";
import shouldShowPostReadMore from "../../utility/shouldShowPostReadMore";
import PollCard from "../NewsFeed/PollCard";

import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';
import { Tooltip } from "@mui/material";

import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";

const postDetailsRequestCache = new Map();

const getCachedPostDetailsRequest = ({ PostId, restrictedViewerTokens, language }) => {
  const cacheKey = `${PostId}_${restrictedViewerTokens || ""}_${language || ""}`;

  if (!postDetailsRequestCache.has(cacheKey)) {
    const request = Promise.all([
      axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${PostId}&RestrictedViewerToken=${restrictedViewerTokens || ""}&langKey=${language || ""}`
      ),
      axios.get(
        `/Posts/LoadAllComments?DeviceType=Web&PostId=${PostId}&langKey=${language || ""}`
      ),
    ]).finally(() => {
      setTimeout(() => {
        postDetailsRequestCache.delete(cacheKey);
      }, 3000);
    });

    postDetailsRequestCache.set(cacheKey, request);
  }

  return postDetailsRequestCache.get(cacheKey);
};


const  Post = () => {
  const guestModeData = localStorage.getItem("guestMode");
  const sessionId = localStorage.getItem("sessionId");
  const { PostId } = useParams();
  const { t } = useTranslation();
  const [postList, setPostList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isError, setIsError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [dLike, setDLike] = useState(0);
  const [singlepostId, setSinglePostId] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
  const [postId, setPostId] = useState("");
  const [activeVideoId, setActiveVideoId] = useState(null);
  const visibleVideoRef = useRef(null);
  const [isfollowed, setIsfollowed] = useState(false);
  const [isLiked, setIsLiked] = useState(false);


  const openModal = (images) => {
    // console.log('clicke');
    setModalImages(images);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [singlePostContent, setSinglePostContent] = useState("");
  const [ispostmodalOpen, setIspostmodalOpen] = useState(false);

  const updateLikeCount = (postId, delta) => {
    setSinglePostList((prev) => {
      if (!prev || prev?.postInfo?.postInfo?.postId !== postId) return prev;

      return {
        ...prev,
        postInfo: {
          ...prev.postInfo,
          postInfo: {
            ...prev.postInfo.postInfo,
            likeCount: (prev.postInfo.postInfo?.likeCount || 0) + delta,
          },
        },
      };
    });

    setSinglePostListInfo((prev) => {
      if (!prev || prev.postInfo?.postId !== postId) return prev;

      return {
        ...prev,
        postInfo: {
          ...prev.postInfo,
          likeCount: (prev.postInfo?.likeCount || 0) + delta,
        },
      };
    });
  };

  const updateCommentCount = (postId, change) => {
    setSinglePostList((prev) => {
      if (!prev || prev?.postInfo?.postInfo?.postId !== postId) return prev;

      return {
        ...prev,
        postInfo: {
          ...prev.postInfo,
          postInfo: {
            ...prev.postInfo.postInfo,
            commentCount: (prev.postInfo.postInfo?.commentCount || 0) + change,
          },
        },
      };
    });

    setSinglePostListInfo((prev) => {
      if (!prev || prev.postInfo?.postId !== postId) return prev;

      return {
        ...prev,
        postInfo: {
          ...prev.postInfo,
          commentCount: (prev.postInfo?.commentCount || 0) + change,
        },
      };
    });
  };

  
  const updateShareCount = (postId, change) => {
    setSinglePostList((prev) => {
      if (!prev || prev?.postInfo?.postInfo?.postId !== postId) return prev;

      return {
        ...prev,
        postInfo: {
          ...prev.postInfo,
          postInfo: {
            ...prev.postInfo.postInfo,
            shareCount: (prev.postInfo.postInfo?.shareCount || 0) + change,
          },
        },
      };
    });

    setSinglePostListInfo((prev) => {
      if (!prev || prev.postInfo?.postId !== postId) return prev;

      return {
        ...prev,
        postInfo: {
          ...prev.postInfo,
          shareCount: (prev.postInfo?.shareCount || 0) + change,
        },
      };
    });
  };

  const [postLikedType, setPostLikedType] = useState(false);
  const handleShowModal = (item) => {
    const selectedPostId =
      item?.postId || item?.postInfo?.postId || item?.postInfo?.postInfo?.postId || "";
    const selectedLikedType =
      item?.likedType ||
      item?.postActionsInfo?.likedType ||
      item?.postInfo?.postActionsInfo?.likedType ||
      item?.postInfo?.postInfo?.postActionsInfo?.likedType ||
      false;

    setPostId(selectedPostId);
    setPostLikedType(selectedLikedType);
    setShowModal(true);
  };
  const handleLikesCloseModal = () => {
    setShowModal(false);
    // setSelectedItem(null);
  };
  const [singlepostList, setSinglePostList] = useState([]);
  const [singlepostListinfo, setSinglePostListInfo] = useState("");
  const language = localStorage.getItem("Lang");
   const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
  const [restrictedViewerToken, setRestrictedViewerToken] = useState('');
  const [singlepostCommentList, setSinglePostCommentList] = useState([]);

  const handleImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = post.noimgavailable;
  };

  console.log("singlepostList+++?", singlepostListinfo);

  const AllPostComments = async () => {
    if (!PostId) return;

    try {
      const commentsResponse = await axios.get(
        `/Posts/LoadAllComments?DeviceType=Web&PostId=${PostId}&langKey=${language || ""}`
      );
      setSinglePostCommentList(commentsResponse?.data?.responseData || []);
    } catch (error) {
      console.log(error);
    }
  };

  const AllPostList = async () => {
    if (!PostId) return;

    setIsLoading(true);
    setIsError(false);

    try {
      const [postResponse, commentsResponse] = await getCachedPostDetailsRequest({
        PostId,
        restrictedViewerTokens,
        language,
      });

      setIsLoading(false);

      if (postResponse.status === 204) {
        setIsError(true);
        return;
      }

      setSinglePostList(postResponse.data.responseData);
      setSinglePostListInfo(postResponse.data.responseData.postInfo);
      setRestrictedViewerToken(postResponse?.data?.responseData?.restrictedViewerToken);
      setSinglePostCommentList(commentsResponse?.data?.responseData || []);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    let isActive = true;

    const loadPostDetails = async () => {
      if (!PostId) return;

      try {
        await AllPostList();

        if (!isActive) return;
      } catch (error) {
        if (!isActive) return;
        console.log(error);
      }
    };

    loadPostDetails();

    return () => {
      isActive = false;
    };
  }, [PostId, restrictedViewerTokens, language]);


const updatePostLike = (postId, isLikedStatus, likedType) => {
  setSinglePostList((prev) => {
    if (!prev || prev?.postInfo?.postInfo?.postId !== postId) return prev;

    return {
      ...prev,
      postInfo: {
        ...prev.postInfo,
        postInfo: {
          ...prev.postInfo.postInfo,
          postActionsInfo: {
            ...prev.postInfo.postInfo.postActionsInfo,
            isLiked: isLikedStatus,
            likedType: likedType,
          },
        },
      },
    };
  });

  setSinglePostListInfo((prev) => {
    if (!prev || prev.postInfo?.postId !== postId) return prev;

    return {
      ...prev,
      postInfo: {
        ...prev.postInfo,
        postActionsInfo: {
          ...prev.postInfo.postActionsInfo,
          isLiked: isLikedStatus,
          likedType: likedType,
        },
      },
    };
  });
};

const updateCommentLike = (postId, commentId, action, likeType = null) => {
  setSinglePostCommentList((prev = []) =>
    prev.map((c) => {
      if (c.pstCmntId !== commentId) return c;

      if (action === "like") {
        return {
          ...c,
          likeCount: (c.likeCount || 0) + 1,
          isLiked: true,
          likedType: likeType,
        };
      }

      if (action === "unlike") {
        return {
          ...c,
          likeCount: Math.max((c.likeCount || 1) - 1, 0),
          isLiked: false,
          likedType: null,
        };
      }

      if (action === "change") {
        return {
          ...c,
          isLiked: true,
          likedType: likeType,
        };
      }

      return c;
    })
  );

  setSinglePostListInfo((prev) => {
    if (!prev || prev.postInfo?.postId !== postId) return prev;

    return {
      ...prev,
      postInfo: {
        ...prev.postInfo,
        comments: (prev.postInfo.comments || []).map((c) => {
          if (c.pstCmntId !== commentId) return c;

          if (action === "like") {
            return {
              ...c,
              likeCount: (c.likeCount || 0) + 1,
              isLiked: true,
              likedType: likeType,
            };
          }

          if (action === "unlike") {
            return {
              ...c,
              likeCount: Math.max((c.likeCount || 1) - 1, 0),
              isLiked: false,
              likedType: null,
            };
          }

          if (action === "change") {
            return {
              ...c,
              isLiked: true,
              likedType: likeType,
            };
          }

          return c;
        }),
      },
    };
  });
};


  // const updateCommentCount = (postId, change) => {
  //   setSinglePostList((prev) =>
  //     prev.map((post) =>
  //       post.postId === postId
  //         ? { ...post, commentCount: post.commentCount + change }
  //         : post
  //     )
  //   );
  // };


const updateReplyCommentLike = (postId, commentId, replyId, action, likeType = null) => {
  setSinglePostCommentList((prev = []) =>
    prev.map((c) => {
      if (c.pstCmntId !== commentId) return c;

      return {
        ...c,
        commentsReplies: (c.commentsReplies || []).map((reply) => {
          if (reply.pstCmntRplyId !== replyId) return reply;

          if (action === "like") {
            return {
              ...reply,
              isLiked: true,
              likeCount: (reply.likeCount || 0) + 1,
              likedType: likeType,
            };
          }

          if (action === "unlike") {
            return {
              ...reply,
              isLiked: false,
              likeCount: reply.likeCount > 0 ? reply.likeCount - 1 : 0,
              likedType: null,
            };
          }

          if (action === "change") {
            return {
              ...reply,
              likedType: likeType,
            };
          }

          return reply;
        }),
      };
    })
  );

  setSinglePostListInfo((prev) => {
    if (!prev || prev.postInfo?.postId !== postId) return prev;

    return {
      ...prev,
      postInfo: {
        ...prev.postInfo,
        comments: (prev.postInfo.comments || []).map((c) => {
          if (c.pstCmntId !== commentId) return c;

          return {
            ...c,
            commentsReplies: (c.commentsReplies || []).map((reply) => {
              if (reply.pstCmntRplyId !== replyId) return reply;

              if (action === "like") {
                return {
                  ...reply,
                  isLiked: true,
                  likeCount: (reply.likeCount || 0) + 1,
                  likedType: likeType,
                };
              }

              if (action === "unlike") {
                return {
                  ...reply,
                  isLiked: false,
                  likeCount: reply.likeCount > 0 ? reply.likeCount - 1 : 0,
                  likedType: null,
                };
              }

              if (action === "change") {
                return {
                  ...reply,
                  likedType: likeType,
                };
              }

              return reply;
            }),
          };
        }),
      },
    };
  });
};


  
  const commentedPost = (item) =>
    formatPostContent(
      item?.postInfo?.postContent,
      item?.postInfo?.dynamicValues
    );

  const processExpandedContent = formatExpandedPostContent;

  const formattedContent1 = formatPostContent(
    singlepostList?.postInfo?.postInfo?.sharedPost?.postContent,
    singlepostList?.postInfo?.postInfo?.sharedPost?.dynamicValues
  );
  // console.log("singlepostList", singlepostList);

  const videoRef = useRef(null);
  const sharedVideoRef = useRef(null);

  useEffect(() => {
    // const videoId = singlepostList?.postInfo?.postInfo?.mediaFilesList?.[0]?.mediaInfo;
    const mediaFiles = singlepostList?.postInfo?.postInfo?.mediaFilesList;
    const videoId = mediaFiles?.length > 0 ? mediaFiles[0]?.mediaInfo : null;
    // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
    const region = "centralindia";

    console.log("videoId:", videoId);
    console.log("token:", restrictedViewerTokens);

    if (!videoId || !restrictedViewerTokens || !videoRef.current) {
      console.error("Missing videoId or token or ref.");
      return;
    }

    const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerTokens });
    // const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerTokens, region: region });
    // console.log("manifestUrl:", manifestUrl);
    let hls;
    let plyrInstance;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        // console.log(" Manifest parsed");
        plyrInstance = new Plyr(videoRef.current, {
          captions: { active: true, update: true, language: "en" },
        });
        // Wait for a short time, then try to play
        videoRef.current.muted = true; // always start muted
        videoRef.current?.play().catch(err => {
          console.warn("Play interrupted", err)  ;
        });

      });
      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js Error:", data);
      });
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      console.log(" Native HLS fallback");
      videoRef.current.src = manifestUrl;
      // plyrInstance = new Plyr(videoRef.current);
      videoRef.current.addEventListener("loadedmetadata", () => {
        videoRef.current?.play();
      });
    }
    return () => {
      // if (plyrInstance) plyrInstance.destroy();
      if (hls) hls.destroy();
    };
  }, [singlepostList, restrictedViewerTokens]);

  const sharedMedia = singlepostList?.postInfo?.postInfo?.sharedPost?.mediaFilesList?.[0];
  const videoId = sharedMedia?.mediaInfo;
  const isSharedVideoVisible = sharedMedia?.mediaType === "Video";

  useEffect(() => {
    let hls;
    let plyrInstance;

    if (!videoId || !restrictedViewerTokens || !isSharedVideoVisible) return;

    const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerTokens });

    const videoEl = sharedVideoRef.current;
    if (!videoEl) return;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(videoEl);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        plyrInstance = new Plyr(videoEl, {
          captions: { active: true, update: true, language: "en" },
        });
        videoEl.muted = true; // always start muted
        videoEl.play().catch(err => {
          console.warn("Autoplay failed", err);
        });
      });
    } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
      videoEl.src = manifestUrl;
      videoEl.addEventListener("loadedmetadata", () => {
        videoEl.play().catch(err => {
          console.warn("Play issue fallback", err);
        });
      });
    }

    return () => {
      if (hls) hls.destroy();
      if (plyrInstance) plyrInstance.destroy();
      if (videoEl) {
        videoEl.pause();
        videoEl.src = "";
      }
    };
  }, [videoId, restrictedViewerTokens]);


   const getRelativeTime = (singlepostList) => {
    console.log("dededede", singlepostList);
    
    const now = moment.utc().local();
    const itemTime = moment
      .utc(singlepostList?.postInfo?.postInfo?.creationTime)
      .local();
  
    const diffSeconds = now.diff(itemTime, "seconds");
    const diffMinutes = now.diff(itemTime, "minutes");
    const diffHours = now.diff(itemTime, "hours");
    const diffDays = now.diff(itemTime, "days");
    const diffMonths = now.diff(itemTime, "months", true);
    const diffYears = now.diff(itemTime, "years", true);
  
    /* JUST NOW */
    if (diffSeconds < 60) {
      return t("Notifications.Just Now");
    }
  
    /* MINUTES */
    if (diffMinutes < 60) {
      return diffMinutes === 1
        ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
        : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
    }
  
    /* HOURS */
    if (diffHours < 24) {
      return diffHours === 1
        ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
        : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
    }
  
    /* DAYS */
    if (diffDays < 30) {
      return diffDays === 1
        ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
        : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
    }
  
    /* MONTHS */
    if (diffMonths < 12) {
      const displayMonth =
        diffMonths >= 0.75 && diffMonths < 1.25
          ? 1
          : Math.round(diffMonths * 2) / 2;
  
      return displayMonth === 1
        ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
        : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
    }
  
    /* YEARS */
    const displayYear =
      diffYears >= 0.75 && diffYears < 1.25
        ? 1
        : Math.round(diffYears * 2) / 2;
  
    return displayYear === 1
      ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
      : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
  };



  const [expandedPosts, setExpandedPosts] = useState({});
  const [postContentMap, setPostContentMap] = useState({});


  const readMore = async (id) => {
  try {
    // If content already exists, just expand
    if (postContentMap[id]) {
      setExpandedPosts((prev) => ({ ...prev, [id]: true }));
      return;
    }

    const res = await axios.get(
      `/Posts/GetPostMainContent?DeviceType=Web&PostId=${id}&langKey=${language}`
    );

    setPostContentMap((prev) => ({
      ...prev,
      [id]: res.data.responseData,
    }));

    setExpandedPosts((prev) => ({
      ...prev,
      [id]: true,
    }));
  } catch (error) {
    console.log(error);
  }
};

  console.log("postContentMap", postContentMap);


  return (
    <>
      <Helmet>
        <title>{`${singlepostList?.postInfo?.postInfo?.userName}`} | Welinkjobs</title>
        <meta
          name="description"
          content={`${singlepostList?.postInfo?.postInfo?.title}`}
        />
        <meta name="keywords" content="newsfeed, updates, latest news" />
        <meta
          property="og:title"
          content={`${singlepostList?.postInfo?.postInfo?.userName} Profile | Welinkjobs`}
        />
        <meta
          property="og:description"
          content={`${singlepostList?.postInfo?.postInfo?.title}`}
        />
        <meta property="og:url" content="https://welinkjobs.com/NewsFeeds" />
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113"
        ></script>
      </Helmet>

      {isLoading ? (
        <PostDetailSkeleton
          variant={(() => {
            const postInfo = singlepostList?.postInfo;
            const loadedPostId = postInfo?.postInfo?.postId;
            const matchesRoute =
              loadedPostId != null && String(loadedPostId) === String(PostId);
            if (!matchesRoute) return "text";

            const category = postInfo?.cntntTypCategory;
            const mediaCount = postInfo?.postInfo?.mediaFilesList?.length || 0;
            const sharedMediaCount =
              postInfo?.postInfo?.sharedPost?.mediaFilesList?.length || 0;

            if (category === "Text") return "text";
            if (mediaCount > 0 || sharedMediaCount > 0 || category === "SharePost") {
              return "media";
            }
            return "text";
          })()}
        />
      ) :
        isError ? (
          <div className="mt-2 d-flex justify-content-center align-items-center">
            <img src={post.errorSmall} alt="404 Not Found" width={200} />
          </div>
        ) : (
          <>
            {singlepostList?.postInfo?.cntntTypCategory === "SharePost" &&
              singlepostList?.postInfo?.cntntTypCategory === "SharePost" ? (
              <div className="row w-100 m-0 singlePostLink">
                <div
                  className={` ${(singlepostList?.postInfo?.postInfo?.sharedPost == [] ||
                    singlepostList?.postInfo?.postInfo?.sharedPost === null)
                    ? "d-none"
                    : "col-md-7"
                    } p-0`}
                >

                  <div className="featured-card user-postOnlyContent p-2 m-2">
                    {/* <div className="feature-content p-2 d-flex justify-content-between">
                      {singlepostList?.postInfo?.postInfo?.postOriginType === "Company" ? (
                        <Link to={`/Company/${singlepostList?.postInfo?.postInfo?.userUid}`}>
                          <div className="d-flex align-items-center">
                            <div className="ImgAvatar">
                              <img
                                src={singlepostList?.postInfo?.postInfo?.userAvatar}
                                alt=""
                                style={{ borderRadius: "50px" }}
                              />
                            </div>
                            <div className="ms-2">
                              <h4 className="f-14 fw-bold mb-0">
                                {singlepostList?.postInfo?.postInfo?.userName}
                              </h4>
                              <p className="f-12">

                                {moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .local()
                                  .format("DD MMMM YYYY [at] h:mm a")}
                              </p>
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Link to={`/User/${singlepostList?.postInfo?.postInfo?.userUid}`}>
                          <div className="d-flex align-items-center">
                            <div className="ImgAvatar">
                              <img
                                src={singlepostList?.postInfo?.postInfo?.userAvatar}
                                alt=""
                                style={{ borderRadius: "50px" }}
                              />
                            </div>
                            <div className="ms-2">
                              <h4 className="f-14 fw-bold mb-0">
                                {singlepostList?.postInfo?.postInfo?.userName}
                              </h4>
                              <p className="f-12">

                                {moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .local()
                                  .format("DD MMMM YYYY [at] h:mm a")}
                              </p>
                            </div>
                          </div>
                        </Link>
                      )}


                    </div>
                    {singlepostList?.postInfo?.postInfo?.postContent && (
                      <div className="f-14 p-2 postContent">
                        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(formattedContent) }} />
                      </div>
                    )} */}
                    <div className="border wlj-shared-original">

                      <div className="feature-content p-2 d-flex justify-content-between align-items-center">
                        {singlepostList?.postInfo?.postInfo?.sharedPost?.postOriginType === "Company" ? (
                          <Link to={`/Company/${singlepostList?.postInfo?.postInfo?.sharedPost?.userUid}`}>
                            <div className="d-flex align-items-center">
                              <div className="ImgAvatar">
                                <img
                                  src={singlepostList?.postInfo?.postInfo?.sharedPost?.userAvatar}
                                  alt=""
                                  style={{ borderRadius: "50px" }}
                                  onError={handleImageError}
                                />
                              </div>
                              <div className="ms-2">
                                <h4 className="f-14 fw-bold mb-0">
                                  {singlepostList?.postInfo?.postInfo?.sharedPost?.userName}
                                </h4>
                                {/* <p className="f-12"> 
                                  {moment
                                    .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                    .local()
                                    .format("DD MMMM YYYY [at] h:mm a")}
                                </p> */}
                                    {language === "ar" ? (
                                                                                  <Tooltip title={moment
                                                                                  .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                                                                  .locale(locale)
                                                                                  .local()
                                                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                                              <p className="f-10 label"> 
                                                                                {moment
                                                                                  .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                                                                  .locale(locale)
                                                                                  .local()
                                                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                                              </p>
                                                                           </Tooltip>
                                                                        ) : (
                                                                          <Tooltip title={moment
                                                                                  .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                                                                  .local()
                                                                                  .format(language === "en"
                                                                                      ? "D MMMM YYYY [at] h:mm a"
                                                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                                              <p className="f-10 label"> 
                                                                          {getRelativeTime(singlepostList)}</p>
                                                                           </Tooltip>
                                                                            
                                
                                                                        )}
                                
                              </div>
                            </div>
                          </Link>
                        ) : (
                          <Link to={`/User/${singlepostList?.postInfo?.postInfo?.sharedPost?.userUid}`}>
                            <div className="d-flex align-items-center">
                              <div className="ImgAvatar">
                                <img
                                  src={singlepostList?.postInfo?.postInfo?.sharedPost?.userAvatar}
                                  alt=""
                                  style={{ borderRadius: "50px" }}
                                  onError={handleImageError}
                                />
                              </div>
                              <div className="ms-2">
                                <h4 className="f-14 fw-bold mb-0">
                                  {singlepostList?.postInfo?.postInfo?.sharedPost?.userName}
                                </h4>
                                {/* <p className="f-12"> 
                                  {moment
                                    .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                    .local()
                                    .format("DD MMMM YYYY [at] h:mm a")}
                                </p> */}
                                    {language === "ar" ? (
                                                  <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.sharedPost?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(singlepostList)}</p>
                                           </Tooltip>
                                            

                                        )}

                              </div>
                            </div>
                          </Link>
                        )}
                        

                        {/* {guestModeData === "true" ? null : (
                                    <div className="row">
                                      <div>
                                        <SinglePostInteraction
                                          postId={singlepostList?.postInfo?.postInfo?.postId}
                                          AllPostList={AllPostList}
                                          singlepostList={singlepostList?.postInfo?.postInfo}
                                          setSinglePostList={setSinglePostList}
                                          // isfollowed={isfollowed}
                                          // setIsfollowed={setIsfollowed}
                                        />
                                      </div>
                                    </div>
                                  )} */}
                                   <div className="d-flex">
                                  {singlepostList?.postInfo?.cntntTypCategory === 'SharePost' ?
                                    (
                                      <>
                                        <span className="me-2">
                                          <p className="badge badge-subtle badge-info1 f-12">
                                            {t("Newsfeed.Shared Post")}
                                          </p>
                                        </span>
                                      </>
                                    )  : null}
                                  <span className="wlj-shared-original-poll-badge badge badge-subtle badge-info1 f-12">
                                    {t("Newsfeed.Poll")}
                                  </span>

                                  </div>
                      </div>
                      {singlepostList?.postInfo?.postInfo?.sharedPost?.postContent && (
                          <Link to={`/Post/${singlepostList?.postInfo?.postInfo?.sharedPost?.postId}`} target="_blank">
                            <div className="f-14 p-2 postContent">
                              <div dangerouslySetInnerHTML={{ __html: formattedContent1 }} />
                            </div>
                          </Link>
                      )}
                      {singlepostList?.postInfo?.postInfo?.sharedPost?.postId && (
                        <div className="wlj-shared-original-poll px-2 pb-1">
                          <PollCard
                            postId={singlepostList.postInfo.postInfo.sharedPost.postId}
                            eager
                            nested
                          />
                        </div>
                      )}
                      <div className="image-slider-modal text-center">
                          {sharedMedia?.mediaType === "Image" || singlepostList?.postInfo?.postInfo?.sharedPost?.mediaFilesList === null ?
                            (
                              <>
                              <Link to={`/Post/${singlepostList?.postInfo?.postInfo?.sharedPost?.postId}`} target="_blank">
                                <ImageWithLoader
                                  src={singlepostList?.postInfo?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaName}
                                  alt=""
                                  className="img-fluid"
                                  width="100%"
                                  onError={handleImageError}
                                />
                              </Link>

                              </>
                            ) : (
                              <div >
                                <video
                                  ref={sharedVideoRef}
                                  controls
                                  autoPlay={false}
                                  muted
                                  width="100%"
                                  height="300"
                                  playsInline
                                  className="video-js"
                                  // style={{ backgroundColor: "#000" }}
                                   style={{ aspectRatio: '16/9', width: '100%', height: 'auto' }} 

                                />
                                {/* <PostVideoCommon file={singlepostListinfo?.postInfo?.mediaFilesList?.[0]?.mediaInfo} item={singlepostListinfo} restrictedViewerToken={restrictedViewerToken} /> */}
                              </div>
                            )

                          }
                          {/* <img
                                          src={singlepostList?.postInfo?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaName}
                                          alt=""
                                          className="img-fluid"
                                          width="100%"
                                        /> */}
                        <div
                          className={`postData d-flex align-items-center `}  >

                          <div
                            style={{
                              marginLeft:
                                singlepostList?.postInfo?.contentInfo?.count === 3
                                  ? "32px"
                                  : "10px",
                            }}
                          >
                            {singlepostList?.postInfo?.postInfo?.sharedPost?.likeCount === 0 || 
                            singlepostList?.postInfo?.postInfo?.sharedPost?.likeCount === null ? (
                              ""
                            ) : (
                              <p
                                className="f-10 like-details"
                                onClick={() => handleShowModal(singlepostList?.postInfo?.postInfo?.sharedPost)}
                              >
                                {/* {singlepostList?.postInfo?.postInfo?.postReactionContent?.text}{" "} */}
                                {singlepostList?.postInfo?.postInfo?.sharedPost?.likeCount} <ThumbUpOutlinedIcon style={{color:"#00419f", fontSize: "13px"}}/>
                                {/* {t("Newsfeed.Like")} */}
                              </p>
                            )}
                          </div>
                          <div className="ms-auto d-flex">
                            {singlepostList?.postInfo?.postInfo?.sharedPost?.commentCount === 0 ||
                            singlepostList?.postInfo?.postInfo?.sharedPost?.commentCount === null ? (
                              ""
                            ) : (
                                <Link to={`/Post/${singlepostList?.postInfo?.postInfo?.sharedPost?.postId}`} target="_blank">
                                  <p
                                    className="f-10 me-2 pointer"  >
                                    {/* {singlepostList?.postInfo?.postInfo?.sharedPost?.commentCount} comments{" "} */}
                                    {singlepostList?.length ?? singlepostList?.postInfo?.postInfo?.sharedPost?.commentCount} <ChatOutlinedIcon 
                                        style={{color:"#00419f", fontSize: "13px"}}/>
                                    {/* {t("Newsfeed.Comment")} */}
                                  </p>
                                </Link>
                               )}
                                <p className="f-10">
                                  {singlepostList?.postInfo?.postInfo?.sharedPost?.shareCount === 0 || 
                                  singlepostList?.postInfo?.postInfo?.sharedPost?.shareCount === null
                                    ? ""
                                    : `&  ${singlepostList?.postInfo?.postInfo?.sharedPost?.shareCount}`} {singlepostList?.postInfo?.postInfo?.sharedPost?.shareCount === 0 || singlepostList?.postInfo?.postInfo?.sharedPost?.shareCount === null
                                    ? ""
                                    : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "13px"}} />
                                     }
                                </p>
                           
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div
                  className={` ${(singlepostList?.postInfo?.postInfo?.sharedPost == [] ||
                    singlepostList?.postInfo?.postInfo?.sharedPost === null)
                    ? "col-md-12"
                    : "col-md-5"
                    } p-0`}
                  style={{ overflowY: "auto", maxHeight: "90vh" }}
                >
                  <div className="featured-card user-postOnlyContent p-2 m-2 pt-0">
                    <div className="feature-content p-2 d-flex justify-content-between">
                          {singlepostList?.postInfo?.postInfo?.postOriginType === "Company" ? (
                            <Link to={`/Company/${singlepostList?.postInfo?.postInfo?.userUid}`}>
                              <div className="d-flex align-items-center">
                                <div className="ImgAvatar">
                                  <img
                                    src={singlepostList?.postInfo?.postInfo?.userAvatar}
                                    alt=""
                                    style={{ borderRadius: "50px" }}
                                    onError={handleImageError}
                                  />
                                </div>
                                <div className="ms-2">
                                  <h4 className="f-14 fw-bold mb-0">
                                    {singlepostList?.postInfo?.postInfo?.userName}
                                  </h4>
                                  {/* <p className="f-12">
                                     
                                    {moment
                                      .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                      .local()
                                      .format("DD MMMM YYYY [at] h:mm a")}
                                  </p> */}
                                      {language === "ar" ? (
                                                  <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(singlepostList)}</p>
                                           </Tooltip>
                                            

                                        )}

                                </div>
                              </div>
                            </Link>
                          ) : (
                            <Link to={`/User/${singlepostList?.postInfo?.postInfo?.userUid}`}>
                              <div className="d-flex align-items-center">
                                <div className="ImgAvatar">
                                  <img
                                    src={singlepostList?.postInfo?.postInfo?.userAvatar}
                                    alt=""
                                    style={{ borderRadius: "50px" }}
                                    onError={handleImageError}
                                  />
                                </div>
                                <div className="ms-2">
                                  <h4 className="f-14 fw-bold mb-0">
                                    {singlepostList?.postInfo?.postInfo?.userName}
                                  </h4>
                                  {/* <p className="f-12">
                                   
                                    {moment
                                      .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                      .local()
                                      .format("DD MMMM YYYY [at] h:mm a")}
                                  </p> */}
                                      {language === "ar" ? (
                                                  <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(singlepostList)}</p>
                                           </Tooltip>
                                            

                                        )}

                                </div>
                              </div>
                            </Link>
                          )}

                          
                          {guestModeData === "true" ? null : (
                        <div className="row">
                          <div>
                            <SinglePostInteraction
                              postId={singlepostList?.postInfo?.postInfo?.postId}
                              AllPostList={AllPostList}
                              singlepostList={singlepostList?.postInfo?.postInfo}
                              singlepostListData={singlepostList?.postInfo}

                              setSinglePostList={setSinglePostList}
                              PostOriginType={"User"}
                              postOriginId={singlepostList?.postInfo?.postInfo?.userUid} 
                              isfollowed={isfollowed}
                              setIsfollowed={setIsfollowed}
                            />
                          </div>
                        </div>
                      )}
                        </div>
                        {singlepostList?.postInfo?.postInfo?.postContent && (
                          
                          <>
                             {!expandedPosts?.[singlepostList.postInfo.postInfo.postId] && ( 
                                  <div
                                    className="postContentDiv f-14"
                                    dangerouslySetInnerHTML={{
                                      __html: commentedPost(singlepostListinfo),
                                    }}
                                  /> 
                                )}
 
                                  {!expandedPosts?.[singlepostList.postInfo.postInfo.postId] &&
                                  shouldShowPostReadMore(
                                    singlepostList?.postInfo?.postInfo?.postContent,
                                    singlepostList?.postInfo?.postInfo?.readMore
                                  ) && (
                                    <span style={{color:"#1051b0"}}
                                      onClick={() => readMore(singlepostList.postInfo.postInfo.postId)}
                                      className="pointer"
                                    >
                                      {t("Newsfeed.Read More")}
                                    </span>
                                  )}
                              
                                  {expandedPosts?.[singlepostList.postInfo?.postInfo.postId] &&
                                  postContentMap?.[singlepostList.postInfo.postInfo.postId] && (
                                    <div
                                      className="postContentDiv f-14"
                                      dangerouslySetInnerHTML={{
                                        __html: processExpandedContent(
                                          postContentMap[singlepostList.postInfo.postInfo.postId],
                                          singlepostList?.postInfo?.postInfo?.dynamicValues
                                        ),
                                      }}
                                    />
                                  )}

                                  {expandedPosts?.[singlepostList.postInfo.postInfo.postId] && (
                                  <span style={{color:"#1051b0"}}
                                    className="pointer"
                                    onClick={() =>
                                      setExpandedPosts((prev) => ({
                                        ...prev,
                                        [singlepostList?.postInfo?.postInfo?.postId]: false,
                                      }))
                                    }
                                  >
                                  {t("Newsfeed.Read Less")}
                                  </span>
                                  )}
                           </>
                               )}

                        {singlepostList?.postInfo?.postInfo?.postId && (
                          <div className="px-2 pb-1">
                            <PollCard postId={singlepostList.postInfo.postInfo.postId} eager />
                          </div>
                        )}

                    <div className="feed-post p-2 pt-1">
                      {guestModeData === "true" ? null : (
                        <div className="row">
                          <div className="addComment">
                            <SinglePostComment
                              isOwnedPost={singlepostList?.postInfo?.postInfo?.isOwned}
                              postId={singlepostList?.postInfo?.postInfo?.postId}
                              AllPostList={AllPostList}
                              AllPostComments={AllPostComments}
                              singlepostList={singlepostList?.postInfo?.postInfo}
                              setSinglePostList={setSinglePostList}
                              ispostmodalOpen={ispostmodalOpen}
                              setIspostmodalOpen={setIspostmodalOpen}
                              setPostList={setPostList}
                              setSinglePostCommentList={setSinglePostCommentList}
                              singlepostCommentList={singlepostCommentList}
                              videoRef={videoRef}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className={`postData d-flex align-items-center ${singlepostList?.postInfo?.postInfo?.likeCount === 0 &&
                        singlepostList?.postInfo?.postInfo?.commentCount === 0 &&
                        singlepostList?.postInfo?.postInfo?.shareCount === 0
                        ? ""
                        : "border-custom1"
                        }`}
                    >
                      <div className="ms-2">
                        {singlepostList?.postInfo?.postInfo?.likeCount + dLike === 0 ||
                         singlepostList?.postInfo?.postInfo?.likeCount + dLike === null ? (
                          ""
                        ) : (
                          <p
                            className="f-10 like-details"
                            onClick={() => handleShowModal(singlepostList?.postInfo?.postInfo)}
                          >
                            {singlepostList?.postInfo?.postInfo?.likeCount + dLike} <ThumbUpOutlinedIcon  style={{color:"#00419f", fontSize: "13px"}}/>
                            
                            {/* {t("Newsfeed.Like")} */}
                          </p>
                        )}
                      </div>
                      <div className="ms-auto d-flex">
                        {singlepostList?.postInfo?.postInfo?.commentCount === 0 || singlepostList?.postInfo?.postInfo?.commentCount === null ? (
                          ""
                        ) : (
                          <p className="f-10 me-2 pointer">
                            {singlepostList?.postInfo?.postInfo?.commentCount} <ChatOutlinedIcon 
                                 style={{color:"#00419f",fontSize: "13px" }}/>
                            {/* {t("Newsfeed.Comment")} */}
                          </p>
                        )}

                        {/* <p className="f-10">
                          {singlepostList?.postInfo?.postInfo?.shareCount === 0 || singlepostList?.postInfo?.postInfo?.shareCount === null
                            ? ""
                            : `&  ${singlepostList?.postInfo?.postInfo?.shareCount} ${t("Newsfeed.Share")}`}
                        </p> */}
                              <p className="f-10">
                                  {singlepostList?.postInfo?.postInfo?.shareCount === 0 || singlepostList?.postInfo?.postInfo?.shareCount === null
                                    ? ""
                                    : `&  ${singlepostList?.postInfo?.postInfo?.shareCount}`} {singlepostList?.postInfo?.postInfo?.shareCount === 0 ||  singlepostList?.postInfo?.postInfo?.shareCount === null
                                    ? ""
                                    : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "13px"}} />
                                     }
                                </p>
                      </div>
                    </div>
                    <div className="postengagement">
                      <SinglePostEngagement
                        setIsLiked={setIsLiked}
                        isLiked={isLiked}
                        isOwnedPost={singlepostList?.postInfo?.postInfo?.isOwned}
                        postId={singlepostList?.postInfo?.postInfo?.postId}
                        AllPostList={AllPostList}
                        AllPostComments={AllPostComments}
                        singlepostList={singlepostList}
                        setSinglePostList={setSinglePostList}
                        ispostmodalOpen={ispostmodalOpen}
                        setIspostmodalOpen={setIspostmodalOpen}
                        openModal={openModal}
                        setSinglePostId={setSinglePostId}
                        setSinglePostContent={setSinglePostContent}
                        setDLike={setDLike}
                        updateLikeCount={updateLikeCount}
                        setSinglePostCommentList={setSinglePostCommentList}
                        singlepostCommentList={singlepostCommentList}
                        singlepostListinfo={singlepostListinfo}
                        setSinglePostListInfo={setSinglePostListInfo}
                        updateCommentLike={updateCommentLike}
                        updatePostLike={updatePostLike}
                        updateReplyCommentLike={updateReplyCommentLike}
                        updateShareCount={updateShareCount}
                        updateCommentCount={updateCommentCount}

                      // setPostList={setPostList}
                      />
                      <LikesDetails
                        showModal={showModal}
                        handleLikesCloseModal={handleLikesCloseModal}
                        postId={postId}
                        postLikedType={postLikedType}
                        setShowModal={setShowModal}
                      />
                    </div>
                  </div>
                </div>

              </div>
            ) : (
              <div className="row w-100 m-0 singlePostLink">
                <div
                  className={` ${(singlepostList?.postInfo?.postInfo?.mediaFilesList == null ||
                    singlepostList?.postInfo?.postInfo?.mediaFilesList == [])
                    ? "d-none"
                    : "col-md-7"
                    } p-0`}
                >
                  <div className="image-slider-modal text-center">
                    {singlepostList?.postInfo?.postInfo?.mediaFilesList?.length > 1 ? (
                      <Slider>
                        {singlepostList?.postInfo?.postInfo?.mediaFilesList?.map(
                          (image, index) => (
                            <div key={index}>
                              <ImageWithLoader
                                src={image.mediaName}
                                alt={`Slide ${index}`}
                                className="img-fluid m-auto modal-image"
                                onError={handleImageError}
                              />
                            </div>
                          )
                        )}
                      </Slider>
                    ) : (
                      <>
                        {singlepostList?.postInfo?.cntntTypCategory !== "TextWithVideo" &&
                          singlepostList?.postInfo?.cntntTypCategory !== "Video" ? (
                          <ImageWithLoader
                            src={singlepostList?.postInfo?.postInfo?.mediaFilesList?.[0]?.mediaName}
                            alt=""
                            className="img-fluid"
                            width="100%"
                            onError={handleImageError}
                          />
                        ) : null}

                        {(singlepostList?.postInfo?.cntntTypCategory === "TextWithVideo" ||
                          singlepostList?.postInfo?.cntntTypCategory === "UserStory" ||
                          singlepostList?.postInfo?.cntntTypCategory === "Video") &&
                          singlepostList?.postInfo?.postInfo?.mediaFilesList?.[0]?.mediaInfo ? (
                          <div  >
                            {/* <iframe
                                      width="100%"
                                      height="300"
                                      src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${singlepostList?.postInfo?.postInfo?.mediaFilesList?.[0]?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`}
                                      frameBorder="0"
                                      allowFullScreen
                                      allow="autoplay; fullscreen"
                                    ></iframe> */}
                            <video
                              ref={videoRef}
                              controls
                              autoPlay={false}
                              muted
                              width="100%"
                              height="300"
                              playsInline
                              className="video-js"
                              // style={{
                              //   backgroundColor: "#000",
                              //   width: "100%",
                              //   // height: "100%",
                              //   // maxHeight: "350px",
                              //   objectFit: "cover",
                              //   display: "block",
                              // }}
                                style={{ aspectRatio: '16/9', width: '100%', height: 'auto' }} 

                            />
                            {/* <PostVideoCommon 
                            file={singlepostList?.postInfo?.mediaFilesList?.[0]?.mediaInfo} 
                            item={singlepostList?.postInfo} 
                            restrictedViewerToken={restrictedViewerToken} 
                            setActiveVideoId={setActiveVideoId}
                            activeVideoId={activeVideoId}
                            AllPostList={AllPostList}
                            setPostList={setPostList}
                            visibleVideoRef={visibleVideoRef}                  /> */}
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>


                </div>

                <div
                  className={` ${(singlepostList?.postInfo?.postInfo?.mediaFilesList == null ||
                    singlepostList?.postInfo?.postInfo?.mediaFilesList == []) &&

                    (singlepostList?.postInfo?.postInfo?.sharedPost?.mediaFilesList == [] ||
                      singlepostList?.postInfo?.postInfo?.sharedPost?.mediaFilesList === null) ||
                    (singlepostList?.postInfo?.cntntTypCategory === 'Text')
                    ? "col-md-12"
                    : "col-md-5"
                    } p-0`}
                  style={{ overflowY: "auto", maxHeight: "90vh" }}
                >
                  <div className="featured-card user-postOnlyContent p-2 m-2">
                    <div className="feature-content p-2 d-flex justify-content-between">
                      {singlepostList?.postInfo?.postInfo?.postOriginType === "Company" ? (
                        <Link to={`/Company/${singlepostList?.postInfo?.postInfo?.userUid}`}>
                          <div className="d-flex align-items-center">
                            <div className="ImgAvatar">
                                  <img
                                    src={singlepostList?.postInfo?.postInfo?.userAvatar}
                                    alt=""
                                    style={{ borderRadius: "50px" }}
                                    onError={handleImageError}
                                  />
                            </div>
                            <div className="ms-2">
                              <h4 className="f-14 fw-bold mb-0">
                                {singlepostList?.postInfo?.postInfo?.userName}
                              </h4>
                              {/* <p className="f-12"> 
                                {moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .local()
                                  .format("DD MMMM YYYY [at] h:mm a")}
                              </p> */}
                                  {language === "ar" ? (
                                                  <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(singlepostList)}</p>
                                           </Tooltip>
                                            

                                        )}

                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Link to={`/User/${singlepostList?.postInfo?.postInfo?.userUid}`}>
                          <div className="d-flex align-items-center">
                            <div className="ImgAvatar">
                                  <img
                                    src={singlepostList?.postInfo?.postInfo?.userAvatar}
                                    alt=""
                                    style={{ borderRadius: "50px" }}
                                    onError={handleImageError}
                                  />
                            </div>
                            <div className="ms-2">
                              <h4 className="f-14 fw-bold mb-0">
                                {singlepostList?.postInfo?.postInfo?.userName}
                              </h4>
                              {/* <p className="f-12"> 
                                {moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .local()
                                  .format("DD MMMM YYYY [at] h:mm a")}
                              </p> */}
                                  {language === "ar" ? (
                                                  <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(singlepostList)}</p>
                                           </Tooltip>
                                            

                                        )}

                            </div>
                          </div>
                        </Link>
                      )}

                      {guestModeData === "true" ? null : (
                        <div className="row">
                          <div>
                            <SinglePostInteraction
                              postId={singlepostList?.postInfo?.postInfo?.postId}
                              AllPostList={AllPostList}
                              singlepostList={singlepostList?.postInfo?.postInfo}
                              singlepostListData={singlepostList?.postInfo}
                              postOriginId={singlepostList?.postInfo?.postInfo?.userUid}
                              setSinglePostList={setSinglePostList}
                              PostOriginType={"User"}
                              setPostList={setPostList}
                              isfollowed={isfollowed}
                              setIsfollowed={setIsfollowed}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    {singlepostList?.postInfo?.postInfo?.postContent && (
                      <div className="f-14 p-2 postContent">
                        <>
                             {!expandedPosts?.[singlepostList.postInfo.postInfo.postId] && ( 
                                  <div
                                    className="postContentDiv f-14"
                                    dangerouslySetInnerHTML={{
                                      __html: commentedPost(singlepostListinfo),
                                    }}
                                  /> 
                                )}
 
                                  {!expandedPosts?.[singlepostList.postInfo.postInfo.postId] &&
                                  shouldShowPostReadMore(
                                    singlepostList?.postInfo?.postInfo?.postContent,
                                    singlepostList?.postInfo?.postInfo?.readMore
                                  ) && (
                                    <span style={{color:"#1051b0"}}
                                      onClick={() => readMore(singlepostList.postInfo.postInfo.postId)}
                                      className="pointer"
                                    >
                                      {t("Newsfeed.Read More")}
                                    </span>
                                  )}
                              
                                  {expandedPosts?.[singlepostList.postInfo.postInfo.postId] &&
                                    postContentMap?.[singlepostList.postInfo.postInfo.postId] && (
                                      <div
                                        className="postContentDiv f-14"
                                        dangerouslySetInnerHTML={{
                                          __html: processExpandedContent(
                                            postContentMap[singlepostList.postInfo.postInfo.postId],
                                            singlepostList?.postInfo?.postInfo?.dynamicValues
                                          ),
                                        }}
                                      /> 
                                    )}

                                  {expandedPosts?.[singlepostList.postInfo.postInfo.postId] && (
                                  <span style={{color:"#1051b0"}}
                                    className="pointer"
                                    onClick={() =>
                                      setExpandedPosts((prev) => ({
                                        ...prev,
                                        [singlepostList?.postInfo?.postInfo?.postId]: false,
                                      }))
                                    }
                                  >
                                  {t("Newsfeed.Read Less")}
                                  </span>
                                  )}
                                </>
                        {/* <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(formattedContent) }} /> */}
                      </div>
                    )}
                    {singlepostList?.postInfo?.postInfo?.postId && (
                      <div className="px-2 pb-1">
                        <PollCard postId={singlepostList.postInfo.postInfo.postId} eager />
                      </div>
                    )}
                    {/* <p className="f-14 p-2">{singlepostList?.postInfo?.postContent}</p> */}
                    <div className="feed-post p-2">
                      {guestModeData === "true" ? null : (
                        <div className="row">
                          <div className="addComment">
                            <SinglePostComment
                              postId={singlepostList?.postInfo?.postInfo?.postId}
                              AllPostList={AllPostList}
                              singlepostList={singlepostList?.postInfo?.postInfo}
                              setSinglePostList={setSinglePostList}
                              ispostmodalOpen={ispostmodalOpen}
                              setIspostmodalOpen={setIspostmodalOpen}
                              setPostList={setPostList}
                              setSinglePostCommentList={setSinglePostCommentList}
                              AllPostComments={AllPostComments}
                              singlepostCommentList={singlepostCommentList}
                              videoRef={videoRef}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className={`postData d-flex align-items-center ${singlepostList?.postInfo?.postInfo?.likeCount === 0 &&
                        singlepostList?.postInfo?.postInfo?.commentCount === 0 &&
                        singlepostList?.postInfo?.postInfo?.shareCount === 0
                        ? ""
                        : "border-custom1"
                        }`}
                    >
                      <div className="ms-2">
                        {singlepostList?.postInfo?.postInfo?.likeCount + dLike === 0 || singlepostList?.postInfo?.postInfo?.likeCount + dLike === null ? (
                          ""
                        ) : (
                          <p
                            className="f-10 like-details"
                            onClick={() => handleShowModal(singlepostList?.postInfo?.postInfo)}
                          >
                            {singlepostList?.postInfo?.postInfo?.likeCount + dLike} <ThumbUpOutlinedIcon  style={{color:"#00419f", fontSize: "13px"}}/>
                            {/* {t("Newsfeed.Like")} */}
                          </p>
                        )}
                      </div>
                      <div className="ms-auto d-flex">
                        {singlepostList?.postInfo?.postInfo?.commentCount === 0 || singlepostList?.postInfo?.postInfo?.commentCount === null ? (
                          ""
                        ) : (
                          <p className="f-10 me-2 pointer">
                            {singlepostList?.postInfo?.postInfo?.commentCount} <ChatOutlinedIcon 
                                 style={{color:"#00419f",fontSize: "13px" }}/>
                            {/* {t("Newsfeed.Comment")} */}
                          </p>
                        )}

                        {/* <p className="f-10">
                          {singlepostList?.postInfo?.postInfo?.shareCount === 0 || singlepostList?.postInfo?.postInfo?.shareCount === null
                            ? ""
                            : `&  ${singlepostList?.postInfo?.postInfo?.shareCount} ${t("Newsfeed.Share")}`}
                        </p> */}
                        <p className="f-10">
                                  {singlepostList?.postInfo?.postInfo?.shareCount === 0 || singlepostList?.postInfo?.postInfo?.shareCount === null
                                    ? ""
                                    : `&  ${singlepostList?.postInfo?.postInfo?.shareCount}`} {singlepostList?.postInfo?.postInfo?.shareCount === 0 || singlepostList?.postInfo?.postInfo?.shareCount === null
                                    ? ""
                                    : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "13px"}} />
                                     }
                                </p>
                      </div>
                    </div>
                    <div className="postengagement">
                      <SinglePostEngagement
                        setIsLiked={setIsLiked}
                        isLiked={isLiked}
                        isOwnedPost={singlepostList?.postInfo?.postInfo?.isOwned}
                        postId={singlepostList?.postInfo?.postInfo?.postId}
                        AllPostList={AllPostList}
                        AllPostComments={AllPostComments}
                        singlepostList={singlepostList}
                        setSinglePostList={setSinglePostList}
                        ispostmodalOpen={ispostmodalOpen}
                        setIspostmodalOpen={setIspostmodalOpen}
                        openModal={openModal}
                        setSinglePostId={setSinglePostId}
                        setSinglePostContent={setSinglePostContent}
                        setDLike={setDLike}
                        updateLikeCount={updateLikeCount}
                        setSinglePostCommentList={setSinglePostCommentList}
                        singlepostCommentList={singlepostCommentList}
                      // setPostList={setPostList}
                       singlepostListinfo={singlepostListinfo}
                            setSinglePostListInfo={setSinglePostListInfo}
                             updateCommentLike={updateCommentLike}
                            updatePostLike={updatePostLike}
                            updateReplyCommentLike={updateReplyCommentLike}
                           updateShareCount={updateShareCount}
                           updateCommentCount={updateCommentCount}
                      />
                      <LikesDetails
                        showModal={showModal}
                        handleLikesCloseModal={handleLikesCloseModal}
                        postId={postId}
                         postLikedType={postLikedType}
                        setShowModal={setShowModal}
                      />
                    </div>
                  </div>
                </div>

              </div>
            )


            }

          </>
        )}







    </>
  );
};

export default Post;
